import React, {
  ReactElement, ReactNode, useMemo, useState,
} from 'react';
import Context, { HistoryPageContextContent } from './HistoryPageContext';

interface Props {
  children: ReactNode;
}

const HistoryPageContextProvider = ({ children }: Props): ReactElement => {
  const [historyPages, setHistoryPages] = useState([]);
  const value: HistoryPageContextContent = useMemo(() => ({
    historyPages,
    setHistoryPages,
  }), [historyPages]);

  return (
    <Context.Provider value={value}>
      {children}
    </Context.Provider>
  );
};

export default HistoryPageContextProvider;
